import { render, staticRenderFns } from "./BancaEmaticaRepartiView.vue?vue&type=template&id=099f9de0"
import script from "./BancaEmaticaRepartiView.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRepartiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports